import { createContext, useContext } from 'react'

export type IViewPageLayoutChrome = {
  showBack?: boolean
  onBack?: () => void
}

type IViewPageLayoutChromeContext = {
  chrome: IViewPageLayoutChrome
  setChrome: (chrome: IViewPageLayoutChrome) => void
}

export const ViewPageLayoutChromeContext = createContext<IViewPageLayoutChromeContext | null>(null)

export const useViewPageLayoutChrome = () => {
  const context = useContext(ViewPageLayoutChromeContext)

  if (context === null) {
    throw new Error(
      'You have forgotten to wrap your root component with ViewPageLayoutChromeContext'
    )
  }

  return context
}
